<template>
  <div v-if="isLoaded" :class="{'hide-tweets': hideTweets}">
    <div v-if="requiresAuthorization">
      <sign-in-to-twitter></sign-in-to-twitter>
    </div>
    <div v-else>
      <v-container fluid class="content-container">
        <v-layout row wrap>
          <v-flex md12>
            <div class="heading then-cardlist heading-top">Tweets</div>
            <div class="page-instructions">
              Due to the current rapidly changing environment at Twitter,
              <br />we have disabled this feature.
              <br />Thank you for your understanding!
            </div>
            <!-- <div class="page-instructions">
              When you click on 'Like' or 'Retweet' to the right of a tweet,
              you will automatically like or retweet that tweet from your Twitter account.
              You will immediately earn the snaps displayed to the right after clicking.
            </div>
            <div v-if="tweets && tweets.length">
              <promoted-tweet :tweet="tweet" v-for="tweet in tweets" :key="tweet.id"></promoted-tweet>
            </div>
            <div v-else>
              <no-content :half="true">There aren't any tweets available right now. Check back soon!</no-content>
              <br />
              <br />
            </div> -->
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import AddTweet from "@/components/Social/AddTweet";
import PromotedTweet from "@/components/Social/PromotedTweet";
import SignInToTwitter from "@/components/Social/SignInToTwitter";
import NoContent from "@/components/Page/NoContent";
import Back from "../modules/Back";
import Cookies from "js-cookie";
import { mapState } from "vuex";

export default {
  name: "YourTweetsPage",
  components: { AddTweet, PromotedTweet, SignInToTwitter, NoContent },
  data: function() {
    return {
      tweets: [],
      hideTweets: true
    };
  },
  computed: {
    isLoaded: function() {
      return this.user;
    },
    requiresAuthorization: function() {
      const value = !(this.user && this.user.is_tw_authorized);

      return value;
    },
    ...mapState({
      user: "user"
    })
  },
  async mounted() {
    var that = this;
    this.tweets = await Back.recommendTweets();

    setTimeout(function() {
      twttr.widgets.load();
    }, 500);
    setTimeout(function() {
      that.hideTweets = false;
    }, 1000);
  }
};
</script>

<style scoped lang="scss">
.page-instructions {
  padding: 4px 0 16px 0;
  font-size: 12.5pt;
  color: #666;
  font-family: $font-family;
}
</style>

<style lang="scss">
.hide-tweets {
  .embed {
    opacity: 0 !important;
  }
}
</style>
